<template>
  <div class="general-info-detail-wrap">
    <div class="header-wrap">
      <div class="title">{{ resultList.monitor_name }}</div>
      <div class="other">
        <span class="time">发布时间：{{ resultList.date_range }}</span>
        <span class="white"></span>
        <span class="origin">阅读：{{ resultList.read_count }}</span>
      </div>
    </div>
    <div class="detail-content">
      <div>
        <TitleCard title="本期最新专利概况" class="infoItem" :showMore="false">
        </TitleCard>
        <div class="item-content">
          <div>
            本期功率半导体器件（{{
              resultList.date_range
            }}）最新公开专利申请共{{ patentTotal }}件,{{ patentStr }}。
          </div>
          <Pie :options="pieEchartOptions" ref="pieChartsInstance"></Pie>
        </div>
      </div>
      <div>
        <TitleCard title="本期主要申请人" class="infoItem" :showMore="false">
        </TitleCard>
        <div>
          <div>
            本期新公开专利中以下申请人申请专利数量较多。（默认显示按公开数据降序排列后，取前十位显示，相同数量排序不分先后）
          </div>
          <a-table
            :columns="fields"
            :data-source="patentData"
            :pagination="false"
            bordered
            class="table"
          >
          </a-table>
        </div>
      </div>
      <div>
        <TitleCard title="本期主要发明人" class="infoItem" :showMore="false">
        </TitleCard>
        <div class="item-content">
          <div>
            本期新公开专利中以下发明人申请专利数量TOP10（默认显示按公开数据降序排列后，取前十位显示，相同数量排序不分先后）
          </div>
          <inventorBar
            :options="inventorBarOptions"
            ref="inventChartsInstance"
          ></inventorBar>
        </div>
      </div>
      <div>
        <TitleCard title="本期主要技术热点" class="infoItem" :showMore="false">
        </TitleCard>
        <div class="item-content">
          <div>本期新公开专利的主要技术热点领域集中在：{{ categoryStr }}。</div>
          <categoryBar
            :options="categoryBarOptions"
            ref="categoryChartsInstance"
          ></categoryBar>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import { getIndustryDetailInfo } from '@/api/IpProject.js'
import Pie from '@/components/echarts/Pie'
import inventorBar from '@/components/echarts/Bar'
import categoryBar from '@/components/echarts/Bar'
import { fields } from '../configs/config'
import { colorArr } from '@/components/echarts/tools'
// import mixinsBackStack from '@/views/backstageSupport/mixins'
export default {
  // mixins: [mixinsBackStack],
  data() {
    return {
      resultList: {
        monitor_name: '功率半导体器件（国内）专利最新动态',
        date_range: '(2021.11.01-2021.11.30)',
        read_count: 10,
        inventor_data:
          '[{"name":"李文","value":24},{"name":"赵云达","value":7},{"name":"宁佐强","value":6},{"name":"蒋军熙","value":6},{"name":"储锋","value":5},{"name":"陶旭东","value":5},{"name":"林佳继","value":4},{"name":"周一新","value":3},{"name":"杨雪龙","value":3},{"name":"陆方明","value":3}]',
        category_data:
          '[{"code":"H01B7/00","name":"按形状区分的绝缘导体或电缆","value":34},{"code":"H01L31/00","name":"对红外辐射、光、较短波长的电磁辐射，或微粒辐射敏感的，并且专门适用于把这样的辐射能转换为电能的，或者专门适用于通过这样的辐射进行电能控制的半导体器件；专门适用于制造或处理这些半导体器件或其部件的方法或设备；其零部件","value":24},{"code":"G01R31/00","name":"电性能的测试装置；电故障的探测装置；以所进行的测试在其他位置未提供为特征的电测试装置","value":20},{"code":"H02B1/00","name":"框架、盘、板、台、机壳；变电站或开关装置的零部件","value":20},{"code":"H01F27/00","name":"变压器或电感器的一般零部件","value":15},{"code":"F23G7/00","name":"专门适用于焚烧特殊废物或低品位燃料","value":9},{"code":"H01B13/00","name":"制造导体或电缆制造的专用设备或方法","value":8},{"code":"H01L21/00","name":"专门适用于制造或处理半导体或固体器件或其部件的方法或设备","value":8},{"code":"H02M3/00","name":"直流功率输入变换为直流功率输出","value":6},{"code":"E04D13/00","name":"与屋面覆盖层有关的特殊安排或设施；屋面排水","value":5}]',
        patent_type_data:
          '[{"name":"发明专利","value":60},{"name":"实用新型","value":212}]',
        patentee_data:
          '[{"name":"无锡奥特维科技股份有限公司","value":17},{"name":"江阴市源达电工材料有限公司","value":8},{"name":"无锡尚德太阳能电力有限公司","value":8},{"name":"远东电缆有限公司","value":7},{"name":"无锡尚品高自动化设备有限公司","value":6},{"name":"普瑞电子(江阴)有限公司","value":6},{"name":"江苏泰利新能源科技有限公司","value":6},{"name":"江苏威翔科技有限公司","value":5},{"name":"无锡市凯达电讯电器有限公司","value":5},{"name":"梵迩佳智能电气有限公司","value":5}]'
      },
      pieEchartOptions: null, // 最新专利饼图
      patentTotal: 0, // 专利总量
      patentStr: '',
      fields,
      patentData: [], // 申请人表格数据
      inventorBarOptions: null, // 发明人柱状图
      categoryBarOptions: null, // 技术热点柱状图
      categoryStr: ''
    }
  },
  components: {
    Pie,
    inventorBar,
    categoryBar
  },
  created() {
    this.loadData()
  },
  methods: {
    getPieOpt(data) {
      return {
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '50%',
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ],
        color: colorArr
      }
    },
    getBar(xData, yData, colorArr, val, list) {
      return {
        xAxis: {
          type: 'category',
          data: xData,
          axisLabel:{
            interval:0
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: params => {
            //
            let str = ''
            if (val === 'category') {
              str =
                list[params.dataIndex].name +
                '</br>' +
                params.marker +
                ' ' +
                params.name +
                '&nbsp;&nbsp;&nbsp;&nbsp;' +
                params.value
            } else {
              str =
                params.marker +
                ' ' +
                params.name +
                '&nbsp;&nbsp;&nbsp;&nbsp;' +
                params.value
            }
            return str
          }
        },
        series: [
          {
            data: yData,
            type: 'bar',
            label: {
              show: true,
              position: 'outside',
              color: colorArr
            }
          }
        ],
        color: colorArr
      }
    },
    async loadData() {
    //   const { id } = this.$route.query
    //   const { data } = await getIndustryDetailInfo(id)
    //   this.resultList = data
      // 最新专利
      let patent_type_data = JSON.parse(this.resultList.patent_type_data)
      patent_type_data.forEach(item => {
        this.patentTotal += Number(item.value)
      })
      patent_type_data.forEach(item => {
        this.patentStr =
          this.patentStr +
          `；${item.name}${item.value}件,占比${(
            item.value / this.patentTotal
          ).toFixed(2) * 100}%`
      })
      this.pieEchartOptions = this.getPieOpt(patent_type_data)
      
      // 申请人表格
      let patentData = JSON.parse(this.resultList.patentee_data)
      patentData.forEach((item, index) => {
        item.key = index + 1
      })
      this.patentData = patentData
      this.patentStr = this.patentStr.slice(1)

      // 发明人
      let inventorXData = []
      let inventorYData = []
      let inventorData = JSON.parse(this.resultList.inventor_data)
      inventorData.forEach(item => {
        inventorXData.push(item.name)
        inventorYData.push(item.value)
      })
      this.inventorBarOptions = this.getBar(
        inventorXData,
        inventorYData,
        colorArr[0],
        '',
        inventorData
      )
      console.log(this.inventorBarOptions)
      // 技术热点
      let categoryXData = []
      let categoryYData = []
      let categoryData = JSON.parse(this.resultList.category_data)
      categoryData.forEach(item => {
        categoryXData.push(item.code)
        categoryYData.push(item.value)
      })
      this.categoryBarOptions = this.getBar(
        categoryXData,
        categoryYData,
        colorArr[1],
        'category',
        categoryData
      )
      categoryData.slice(0, 3).forEach(item => {
        this.categoryStr += `、${item.code}(${item.name})`
        this.categoryStr = this.categoryStr.slice(1)
      })
      console.log(this.categoryBarOptions)
      this.$nextTick(() => {
        this.$refs.pieChartsInstance.initChart()
        this.$refs.inventChartsInstance.initChart()
        this.$refs.categoryChartsInstance.initChart()
      })
    }
  }
}
</script>
